import { render } from "./LikedIcon.vue?vue&type=template&id=6712bad9"
import script from "./LikedIcon.vue?vue&type=script&lang=js"
export * from "./LikedIcon.vue?vue&type=script&lang=js"
script.render = render

export default script